"use client";

import { useId } from "react";
import { MemoizedMarkdown } from "@/components/ui/MemoizedMarkdown";
import { looksLikeSlackMrkdwn } from "../detect";
import { slackMrkdwnToMarkdown } from "../markdown-dialects";
import { PRIORITY, type ValueRenderer } from "../types";

const SLACK_NODE_RE = /slack/i;

export const SlackMrkdwnRenderer: ValueRenderer = {
  id: "slack-mrkdwn",
  match: (value, ctx) => {
    if (typeof value !== "string") return null;
    const nodeHint = ctx.nodeType != null && SLACK_NODE_RE.test(ctx.nodeType);
    // On a Slack node this dialect renderer must outrank the generic
    // MarkdownRenderer (also CONTEXT_HINTED on content keys) — otherwise Slack
    // mrkdwn syntax under an `output` key would render literally.
    if (nodeHint && value.length > 0) return { priority: PRIORITY.CONTEXT_HINTED + 1, confidence: "high" };
    if (looksLikeSlackMrkdwn(value)) return { priority: PRIORITY.CONTENT_SNIFFED, confidence: "high" };
    return null;
  },
  Component: ({ value }) => {
    const id = useId();
    return (
      <div className="text-sm">
        <MemoizedMarkdown content={slackMrkdwnToMarkdown(value as string)} id={id} />
      </div>
    );
  },
};
